"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = exports.SBTitle = exports.SBRow = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = require("../colors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// export const G = styled.g``;

var Svg = _styledComponents["default"].svg.attrs(function () {
  return {
    xmlns: 'http://www.w3.org/2000/svg',
    version: '1.1'
  };
}).withConfig({
  displayName: "styles__Svg",
  componentId: "sc-sr0uoi-0"
})(["g{fill:", ";}", " ", ""], _colors.thdOrange, function (props) {
  return props.color && (0, _styledComponents.css)(["g{fill:", ";}"], props.color);
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(["opacity:0.54;g{fill:", ";}"], _colors.borderColor);
});
exports.Svg = Svg;
var SBRow = _styledComponents["default"].div.withConfig({
  displayName: "styles__SBRow",
  componentId: "sc-sr0uoi-1"
})(["display:block;box-sizing:border-box;padding:10px;margin:10px;"]);
exports.SBRow = SBRow;
var SBTitle = _styledComponents["default"].h2.withConfig({
  displayName: "styles__SBTitle",
  componentId: "sc-sr0uoi-2"
})(["display:block;font-size:16px;font-weight:bolder;box-sizing:border-box;border-bottom:1px solid #ccc;padding:10px;margin-bottom:10px;"]);
exports.SBTitle = SBTitle;
//# sourceMappingURL=styles.js.map